import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Widget } from "datastake-daf/dist/components";

const Style = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .row-cont {
    flex: 1;
    display: flex;
    gap: var(--size-md);
    padding: var(--size-lg) 0;
    justify-content: space-between;
    border-bottom: 1px solid var(--base-gray-30);

    .flex {
      overflow: hidden;
      display: flex;
    }

    .label-cont {
      min-width: 65px;
    }

    h5 {
      font-size: 14px;
      margin-bottom: 0px;
      font-weight: 500;
      color: var(--base-gray-70);
      white-space: no-wrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    h2 {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0px;
      color: var(--base-gray-90);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:first-of-type {
      padding-top: 0px;
    }

    &:last-of-type {
      padding-bottom: 0px;
      border-bottom: 0px;
    }
  }
`;

export default function Overview({ type, data = [], loading }) {
  const { t } = useTranslation();

  const getTitle = () => {
    switch (type)  {
      case 'stakeholder':
        return 'Entity Details';
      case 'location':
        return 'Location Details';
      default:
        return 'Overview';
    }
  }

  return (
    <Widget
      loading={loading}
      title={t(getTitle())}
      className="with-border-header widget-custom-type-a"
    >
      <Style>
        {data.map((item, i) => (
          <div className="row-cont" key={`row-${i}`}>
            <div className="flex label-cont flex-column justify-content-center">
              <h5>{t(item.label)}</h5>
            </div>
            <div className="flex flex-column justify-content-center">
              <h2>{item.value}</h2>
            </div>
          </div>
        ))}
      </Style>
    </Widget>
  )
}
